/**
 * Copyright (c) 2023 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : locale_es.jsx
 * description   : {{insert here}}
 * creation date : 11/11/2023
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    locale_msg,
} from '@/utils/locale/enums';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const es_MX =
{
    [locale_msg.COGNITO_AUTH__SIGN_IN__HEADER]: 'Acceda a su cuenta',
    [locale_msg.COGNITO_AUTH__SIGN_IN__TAB]: 'Iniciar sesión',
    [locale_msg.COGNITO_AUTH__SIGN_IN__BUTTON]: 'Iniciar sesión',
    [locale_msg.COGNITO_AUTH__SIGN_IN__TRY]: 'Iniciando sesión',
    [locale_msg.COGNITO_AUTH__SIGN_IN__RESET_PASSWORD]: 'Olvidé mi contraseña',

    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__HEADER]: 'Crear una nueva cuenta',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__TAB_AND_BUTTON]: 'Registrarse',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__TRY]: 'Creando una nueva cuenta',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__BACK_TO_SIGN_IN]: 'Volver al inicio de sesión',

    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__HEADER]: 'Código de confirmación',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__CONFIRM]: 'Confirmar',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__CONFIRMING]: 'Confirmando',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__RESEND_CODE]: 'Reenviar el código',

    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__HEADER]: 'Reiniciar la contraseña',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__SEND_CODE]: 'Enviar el código',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__SENDING]: 'Enviando',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__BACK_TO_SIGN_IN]: 'Volver al inicio de sesión',

    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__HEADER]: 'Reiniciar la contraseña',
    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__SUBMIT]: 'Enviar',
    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__SUBMITTING]: 'Enviando',

    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__HEADER]: 'Reiniciar la contraseña',
    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__CHANGE_PASSWORD]: 'Enviar',
    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__CHANGING]: 'Enviando',

    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__HEADER]: 'Verifique su correo electrónico',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__VERIFY]: 'Verificar',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__VERIFYING]: 'Verificando',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__SKIP]: 'Omitir',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__EMAIL]: 'Correo electrónico',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__CODE]: 'Código de confirmación',

    [locale_msg.COGNITO_AUTH__CONFIRM_VALIDATE_PASSWORD__HEADER]: 'Verifique su correo electrónico',

    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__EMAIL]: 'Correo electrónico:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NAME]: 'Nombre:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__FAMILY_NAME]: 'Apellidos:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NICKNAME]: 'Empresa:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__PHONE_NUMBER]: 'Número de teléfono:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__PASSWORD]: 'Contraseña:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRM_PASSWORD]: 'Confirmar contraseña:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRMATION_CODE]: 'Código de confirmación:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NEW_PASSWORD]: 'Nueva contraseña:',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRM_NEW_PASSWORD]: 'Confirmar la contraseña:',

    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__EMAIL]: 'Ingrese su correo electrónico',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NAME]: 'Ingrese su nombre',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__FAMILY_NAME]: 'Ingrese sus apellidos',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NICKNAME]: 'Ingrese su empresa',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__PHONE_NUMBER]: 'Ingrese su no. de teléfono',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__PASSWORD]: 'Ingrese su contraseña',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRM_PASSWORD]: 'Confirme su contraseña',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRMATION_CODE]: 'Ingrese el código de confirmación',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NEW_PASSWORD]: 'Ingrese su nueva contraseña',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRM_NEW_PASSWORD]: 'Confirme su nueva contraseña',

    [locale_msg.GENERAL__COPYRIGHT]: 'Todos los derechos reservados',
    [locale_msg.GENERAL__LOG_IN]: 'Conectarse',
    [locale_msg.GENERAL__LOG_OUT]: 'Cerrar sesión',
};



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    es_MX,
};



// End of file
